// app/javascript/controllers/menu_dropdown_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "icon"]
  
  connect() {
    this.timeout = null
    this.isOpen = false
  }
  
  // Método que verifica o tamanho da tela
  isMobile() {
    return window.innerWidth < 1024 // lg breakpoint
  }
  
  // Click handler (mobile)
  toggle(event) {
    if (this.isMobile()) {
      // Só previne o comportamento padrão se o clique foi no botão, não nos links
      const clickedElement = event.target.closest('button')
      if (clickedElement) {
        event.preventDefault()
        this.isOpen = !this.isOpen
        
        if (this.isOpen) {
          this.showMobile()
        } else {
          this.hideMobile()
        }
      }
    }
  }
  
  // Mouse handlers (desktop)
  mouseEnter(event) {
    if (!this.isMobile()) {
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
      this.showDesktop()
    }
  }

  mouseLeave(event) {
    if (!this.isMobile()) {
      this.timeout = setTimeout(() => {
        this.hideDesktop()
      }, 50)
    }
  }
  
  showMobile() {
    const dropdown = this.element.querySelector("div")
    const optionsDiv = dropdown.querySelector("div")

    if (dropdown && optionsDiv) {
      dropdown.classList.remove('hidden', 'absolute', 'z-10', 'w-[400px]', 'shadow-lg', 'border', 'rounded-lg')
      dropdown.classList.add('block', 'w-full', 'bg-gray-50', 'border-t')

      optionsDiv.classList.remove("p-4")
      
      // Rotacionar ícone
      const icon = this.element.querySelector("svg")
      if (icon) {
        icon.classList.add('rotate-180')
      }
    }
  }
  
  // Esconder no mobile
  hideMobile() {
    const dropdown = this.element.querySelector("div")
    if (dropdown) {
      dropdown.classList.add('hidden')
      dropdown.classList.remove('block')
      
      // Rotacionar ícone de volta
      const icon = this.element.querySelector("svg")
      if (icon) {
        icon.classList.remove('rotate-180')
      }
    }
  }
  
  // Mostrar no desktop (flutuante)
  showDesktop() {
    const dropdown = this.element.querySelector("div")
    if (dropdown) {
      dropdown.classList.remove('hidden', 'w-full', 'bg-gray-50', 'border-t')
      dropdown.classList.add('block', 'absolute', 'z-10', 'w-[400px]', 'shadow-lg', 'border', 'rounded-lg', 'bg-white')
    }
  }
  
  // Esconder no desktop
  hideDesktop() {
    const dropdown = this.element.querySelector("div")
    if (dropdown) {
      dropdown.classList.add('hidden')
      dropdown.classList.remove('block')
    }
  }
  
  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }
}